<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    itemClass: {
      type: Function,
      default: () => {}
    },
    rows: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<template>
  <v-data-table
    disable-filtering
    disable-sort
    :headers="columns"
    :items="rows"
    :item-class="itemClass"
    @click:row="$emit('click:row', $event)"
  >
    <template
      v-for="{ format, value: key } in columns"
      v-slot:[`item.${key}`]="{ isMobile, item, header, value, index }"
    >
      <slot
        :name="`item.${key}`"
        v-bind="{ format, isMobile, item, header, value, index }"
      >
        <template v-if="format">
          {{ format(value) }}
        </template>
        <template v-else>
          {{ value }}
        </template>
      </slot>
    </template>
  </v-data-table>
</template>

<style lang="scss" scoped></style>
